<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>Equipment</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row options-bar">
						<button class="add-item btn-equipment" @click="addOpen = true">Add Item <i class="ss-plus ss-glyphish-filled"></i></button>
						<Search v-on:foundItems="filteredList" defaultText="Search Equipment" :items="equipment"/>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :equipment="foundEquipment.length ? foundEquipment : equipment" @edit="editEquipment" @delete="deleteEquipment"/>
				</div>
			</div>
			<Add v-if="addOpen" @close="addOpen = false"/>
			<Edit v-if="editOpen" @close="editOpen = false" :equipment="selected"/>
			<Delete v-if="deleteOpen" @close="deleteOpen = false" :equipment="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import Search from '../Form/Search.vue'
import List from '../Equipment/List.vue'
import Add from '../Equipment/Add.vue'
import Edit from '../Equipment/Edit.vue'
import Delete from '../Equipment/Delete.vue'

export default { 
	components: {
		List,
		Add,
		Edit,
		Delete,
		Search
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			addOpen: false,
			foundEquipment: []
		}
	},
	computed : {
		...mapState({
			equipment: state => state.equipment.list
		})
	},
	methods: {
		deleteEquipment(equipment) {
			this.selected = equipment
			this.deleteOpen = true
		},
		editEquipment(equipment) {
			this.selected = equipment
			this.editOpen = true
		},
		filteredList(items) {
			if(items.length > 0) {
				this.foundEquipment = items;
			} 
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const equipment = this.$store.dispatch('equipment/getList')

		Promise.all([equipment])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/Equipment.vue